import { render } from "./EventStatistics.vue?vue&type=template&id=227249f4&scoped=true"
import script from "./EventStatistics.vue?vue&type=script&lang=js"
export * from "./EventStatistics.vue?vue&type=script&lang=js"

import "./EventStatistics.vue?vue&type=style&index=0&id=227249f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227249f4"]])

export default __exports__